"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VdfBrandFlag = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const brand_provider_1 = require("../../providers/brand.provider");
const BrandFlag_1 = require("../BrandFlag");
function VdfBrandFlag({ businessUnit }) {
    const isBrandDifferentFromStore = businessUnit
        ? !brand_provider_1.BrandProvider.isSameBusinessUnitAsStore(businessUnit)
        : false;
    return businessUnit && isBrandDifferentFromStore ? ((0, jsx_runtime_1.jsx)(BrandFlag_1.BrandFlag, { businessUnit: businessUnit })) : null;
}
exports.VdfBrandFlag = VdfBrandFlag;
